import Link from 'next/link'

import { DirectoryLinkAs, DirectoryLinkHref, WithResultType } from 'utils/DirectoryParser'
import { fetchFontAwesomeFacetIcon } from './Utils'
import { StylizedA, StyledFacet } from './Styled'

const SearchInputs = ({
  directoryLinkInformation,
  siteDirectoryResultsTypes,
  directoryResultsType,
}) => {
  if (!siteDirectoryResultsTypes || siteDirectoryResultsTypes.length === 0) {
    return null
  }

  return siteDirectoryResultsTypes.map((siteDirectoryResultsType, index) => {
    const newDirectoryLinkInformation = WithResultType(
      directoryLinkInformation,
      siteDirectoryResultsTypes,
      siteDirectoryResultsType.type
    )
    const href = DirectoryLinkHref(newDirectoryLinkInformation)
    const as = DirectoryLinkAs(newDirectoryLinkInformation)
    const checked = directoryResultsType === siteDirectoryResultsType.type
    const icon = fetchFontAwesomeFacetIcon('radio', checked)

    return (
      <Link key={index} scroll={false} href={href} as={as}>
        <StylizedA>
          <StyledFacet>{icon}</StyledFacet>
          {siteDirectoryResultsType.keyword}
        </StylizedA>
      </Link>
    )
  })
}

export default SearchInputs
